import { Box, Typography } from "@mui/material";

export const BlankPreview = ({ title, subtitle, icon , sx={} }) => {
  return (
    <Box
      sx={{
        minHeight: "50vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--app-surface)",
        backgroundImage:"cover",
        backgroundPosition:"center",
        backgroundRepeat:"no-repeat",
        borderRadius:"9px",
        ...sx,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 420,
          px: 2,
        }}
      >
        {/* Illustration */}
        {icon && (
          <Box
            component="img"
            src={icon}
            alt="Access restricted"
            sx={{
              width: 220,
              maxWidth: "100%",
              mb: 3,
            }}
          />
        )}

        {/* Title */}
        {title && (
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              color: "var(--app-text)",
              mb: 1,
            }}
          >
            {title}
          </Typography>
        )}

        {/* Subtitle */}
        {subtitle && (
          <Typography
            sx={{
              fontSize: "14px",
              color: "#656565",
              lineHeight: 1.6,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
